import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import y from 'y4/Utils';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

const EmbedPage = ({ form, panel }) => {
  const iframeRef = useRef(null);
  const { t } = useTranslation('data');
  const load_title = y.fne(y.gpv(panel, 'option.load.title'), t('Loading....'));
  const load_message = y.fne(
    y.gpv(panel, 'option.load.message'),
    t('Data is still loading, please wait')
  );

  const [data, setData] = useState({
    error: 1,
    errorTitle: load_title,
    errorDescription: load_message
  });

  function setDataAndDispatch(d) {
    setData(d);
    form.eventTarget.dispatchEvent(
      new CustomEvent('afterPanelLoaded', {
        detail: {
          panel: panel,
          data: d
        }
      })
    );
  }

  function setIframeHeight(iframe) {
    if (iframe) {
      if (panel.embedPage.height) {
        iframe.height = panel.embedPage.height;
      } else {
        var iframeWin =
          iframe.contentWindow || iframe.contentDocument.parentWindow;
        if (iframeWin.document.body) {
          const h =
            iframeWin.document.documentElement.scrollHeight ||
            iframeWin.document.body.scrollHeight;
          iframe.height = h;
        }
      }
    }
  }

  //events
  useEffect(() => {
    form.eventTarget.addEventListener('form-event', e => {
      const event = e.detail.event;
      const path = 'events.listen' + y.firstCharToUpper(event);
      const script = y.gpv(panel, path);
      if (script) {
        const f = Function('y', 'source', 'target', script);
        f(y, e.detail, { form, panel, data, setData, setDataAndDispatch });
      }
    });
  }, [form.eventTarget]);

  //after page loaded
  useEffect(() => {
    //first from static url
    if (panel.embedPage.url) {
      setDataAndDispatch({
        url: panel.embedPage.url,
        title: panel.title
      });
    }
  }, []);

  //set iframe height after data.url changed
  useEffect(() => {
    const iframe = iframeRef.current;
    setIframeHeight(iframe);
  }, [data.url]);

  //set iframe attr
  var props = JSON.parse(panel.embedPage.props);

  return (
    data &&
    (data.error ? (
      <>
        <h5 className="mb-0 mt-1">{data.errorTitle}</h5>
        <div className="pt-3">{data.errorDescription}</div>
      </>
    ) : (
      <>
        <iframe
          ref={iframeRef}
          width="100%"
          src={data.url}
          allowFullScreen={true}
          title={data.title}
          {...props}
        />
        <Button variant="link" href={data.url} target={'_block'}>
          {t('Open in new page')}
        </Button>
      </>
    ))
  );
};

EmbedPage.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object
};

export default EmbedPage;
